import Model, { attr } from '@ember-data/model';
import { computed } from '@ember/object';

/**
 * @classdesc
 * Model for storing user profile information.
 */
export default class ProfileModel extends Model {
    /**
     * First name of user.
     */
    @attr('string')
    declare firstName: string;

    /**
     * Last name of user.
     */
    @attr('string')
    declare lastName: string;

    /**
     * Email of user.
     */
    @attr('string')
    declare email: string;

    /**
     * Mobile phone number of user.
     */
    @attr('number')
    declare mobileNumber: number;

    /**
     * Zip code of user.
     */
    @attr('string')
    declare zipCode: string;

    /**
     * User profile creation date.
     */
    @attr('date')
    declare createdAt: Date;

    /**
     * User profile last updated date.
     */
    @attr('date')
    declare updatedAt: Date;

    /**
     * Whether a forced password reset is required.
     */
    @attr('boolean', { defaultValue: false })
    declare forcePasswordReset: boolean;

    /**
     * Whether user's credit card has been validated.
     */
    @attr('boolean', { defaultValue: false })
    declare creditCardValidated: boolean;

    /**
     * User's desired move in date.
     */
    @attr('date')
    declare targetMoveInDate: Date;

    /**
     * Return full name of user.
     *
     * @type {String}
     */
    @computed('firstName', 'lastName')
    get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
    export default interface ModelRegistry {
        profile: ProfileModel;
    }
}
